import type {
  AccessTokenConsumer,
  AccessTokenResponseFunction,
  GraphCreateNewResponse,
} from "../types";

export interface VroomApiOptions {
  correlationId: string;
  getAccessToken: AccessTokenResponseFunction;
  inMockMode?: boolean;
  isConsumer?: boolean;
  jwtAuthEnabled?: boolean;
  officeHomeApiRoot: string;
  oneDriveResourceId?: string;
  oneDriveConsumerApi?: string;
  sharePointResourceId?: string;
}

export interface ESSOptions {
  isESSEnabled?: boolean;
  wacDataCenter?: string;
  sessionId?: string;
  hostCorrelationId?: string;
}

export interface OptionsHttpRequestHeaders {
  Authorization: string;
  SessionId: string;
}

export interface VroomRequestCacheItem<T> {
  promise: Promise<T>;
  expiryTime?: Date;
}

export type Action = "open" | "editnew" | "view" | "edit";

export interface VroomApiInfo {
  baseUrl: string;
  tokenType: AccessTokenConsumer;
  resourceUrl: string;
  hostname: string;
}

// A wrapper interface for a configuration object that can be used to configure a request
export interface HttpRequestOptions {
  method: HttpRequestMethod;
  url: string;
  body?: HttpRequestBody;
  headers?: HttpHeaders;
  params?: { [param: string]: string | Array<string> };
  responseType?: HttpResponseContentType;
}

enum HttpResponseContentType {
  Json = "json",
  Text = "text",
  ArrayBuffer = "arraybuffer",
  Blob = "blob",
}

export type HttpRequestBody =
  | object
  | string
  | Blob
  | File
  | FormData
  | ArrayBuffer
  | ArrayBufferView
  | URLSearchParams;

export interface HttpDataResponse<T> {
  data?: T;
  status: number;
  headers: HttpHeaders;
  ok: boolean;
  statusText: string;
}

export type GraphCreateNewHttpResponse =
  HttpDataResponse<GraphCreateNewResponse>;

export enum HttpRequestMethod {
  Delete = "DELETE",
  Get = "GET",
  Head = "HEAD",
  Options = "OPTIONS",
  Post = "POST",
  Put = "PUT",
  Patch = "PATCH",
}

export type HttpHeaders = { [name: string]: string };
